<template>
  <div class="vcookies">
    <div class="content">
      <div>
        <span
          v-html="
            $tr('cookies.description', { privacy_link: `https://vcv.${this.current_domain}/pages/privacy-policy` })
          "
        >
        </span>
        &nbsp;
        <a class="vcookies__link" :href="cookiesInfoLink" target="_blank" rel="noopener">{{ $tr('cookies.more') }}</a>
      </div>

      <div class="button-wrapper">
        <vbutton label="cookies.accept" :color="'grey'" @click="$emit('submit')" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VcookiesNotification',

  props: {
    locale: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      isCookieAccepted: null
    };
  },

  computed: {
    cookiesInfoLink() {
      if (this.lang_params === 'ru') {
        return 'https://vcv.ru/pages/cookies/'
      } else if (this.lang_params === 'en') {
        return 'https://vcv.ai/pages/cookies/';
      } else if (this.lang_params === 'ja') {
        return 'https://vcv.co.jp/privacy_policy';
      } else {
        return 'https://vcv.ai/pages/cookies/';
      }
    },

    lang_params() {
      return this.$route.params && this.$route.params.lang ? this.$route.params.lang : this.locale;
    },

    current_domain() {
      return this.$store.getters['services/current_domain'];
    }
  },

  created() {
    this.$store.commit('services/set_current_domain');
  },

  beforeDestroy() {
    this.$store.commit('services/clear');
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/queries.scss';

.vcookies {
  position: fixed;
  bottom: 0;
  left: 0;
  min-height: 100px;
  display: flex;
  align-items: center;
  width: 100%;
  color: #fff;
  background: $green;
  padding: 0 25px;
  z-index: 999999;

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    min-height: auto;
  }

  .content {
    width: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 18px 0;
    font-size: 17px;
    font-weight: 300;
    line-height: 25px;
    letter-spacing: 0.005em;

    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
      padding: 30px 0;
    }

    @include widescreen {
      max-width: 820px;
    }

    @include desktop {
      max-width: 100%;
      padding-left: 32px;
      padding-right: 32px;
    }

    @include tablet {
      max-width: 100%;
      padding-left: 10px;
      padding-right: 10px;
      flex-direction: column;
    }
  }

  .vcv-button {
    &.vcookies-button {
      color: #fff;
      background: transparent;
      border-color: #fff;

      &:hover,
      &:focus,
      &:active {
        color: #fff;
        background: transparent;
        border-color: #fff;
      }
    }
  }
}

.vcookies__link {
  display: inline-block;
  vertical-align: middle;
  text-decoration: underline;
}

.button-wrapper {
  margin-left: 20px;

  @include tablet {
    margin-left: auto;
    margin-right: auto;
    margin-top: 20px;
  }
}
</style>

<style lang="scss">
.vcookies {
  .content {
    a {
      color: #fff;

      &:hover,
      &:focus,
      &:active {
        color: #fff;
        text-decoration: none;
      }
    }
  }
}
</style>
